import React from 'react';
import AdminUserManagementListContainer from '@src/components/user/list/AdminUserManagementListContainer';

const AdminUsersManagementPage = () => <AdminUserManagementListContainer />;

export default AdminUsersManagementPage;
